module.exports = __webpack_public_path__ + "img/loginbg.329096ef.png";